import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-component-for-builder',
  templateUrl: './general-component-for-builder.component.html',
  styleUrls: ['./general-component-for-builder.component.css']
})
export class GeneralComponentForBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
